export const initialPagination = {
  currentPage: 1,
  pageCount: 1,
  perPage: 20,
  totalCount: 0,
}
